/* Индикаторы шапки: режим движка, активность API, статус WS-соединения. */
import { useEffect, useRef, useState } from 'react'

import { useAppStore } from '@/store/useAppStore'
import type { EngineMode } from '@/lib/types'
import type { WsStatus } from '@/lib/ws'

export function ModeBadge({ mode }: { mode: EngineMode | null }) {
  if (mode === null) {
    return (
      <span className="mode-badge mode-badge--dry" title="Режим неизвестен">
        —
      </span>
    )
  }
  const live = mode === 'live'
  return (
    <span
      className={`mode-badge ${live ? 'mode-badge--live' : 'mode-badge--dry'}`}
      title={live ? 'Боевой режим (реальные средства)' : 'Симуляция (без реальных средств)'}
    >
      {live ? 'LIVE' : 'DRY-RUN'}
    </span>
  )
}

/** Мигает при наличии in-flight запросов фронта (индикатор активности API). */
export function ApiActivity() {
  const busy = useAppStore((s) => s.apiBusy)
  return (
    <span
      className={`api-led${busy ? ' is-busy' : ''}`}
      title={busy ? 'Идёт обмен с API' : 'API простаивает'}
    >
      <span className="api-led__core" />
      <span className="api-led__label">API</span>
    </span>
  )
}

/** §104: индикатор запросов БОТА на биржи (не HTTP фронта). Загорается, когда монотонный
 *  счётчик ``exchange_request_count`` прирастает между опросами, и гаснет через короткую
 *  паузу. Так оператор видит реальную сетевую активность бота к биржам. */
export function BotApiActivity({ count }: { count: number }) {
  const [active, setActive] = useState(false)
  const prev = useRef(count)
  useEffect(() => {
    if (count === prev.current) return
    prev.current = count
    setActive(true)
    const id = setTimeout(() => setActive(false), 1100)
    return () => clearTimeout(id)
  }, [count])
  return (
    <span
      className={`api-led${active ? ' is-busy' : ''}`}
      title={active ? 'Бот отправляет запросы на биржи' : 'Нет запросов бота к биржам'}
    >
      <span className="api-led__core" />
      <span className="api-led__label">API</span>
    </span>
  )
}

const WS_LABEL: Record<WsStatus, string> = {
  open: 'Онлайн',
  connecting: 'Подключение…',
  closed: 'Оффлайн',
}

export function ConnectionDot({ status }: { status: WsStatus }) {
  const cls =
    status === 'open' ? 'status-dot--on' : status === 'connecting' ? 'status-dot--err' : 'status-dot--off'
  return (
    <span className="api-led" title={`WS: ${WS_LABEL[status]}`}>
      <span className={`status-dot ${cls}`} />
      <span className="api-led__label">{WS_LABEL[status]}</span>
    </span>
  )
}
